import type { SelectHTMLAttributes } from 'react';
import clsx from 'clsx';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
}

export function Select({ label, className, children, ...props }: SelectProps) {
  return (
    <label className={clsx('select-control', className)}>
      {label ? <span className="select-control__label">{label}</span> : null}
      <select {...props}>{children}</select>
    </label>
  );
}
